/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;max-width:850px;overflow:hidden;height:100%}.canvas-viewport[_ngcontent-%COMP%]{display:block;position:relative;height:100%}.canvas-viewport[_ngcontent-%COMP%]   #svg-canvas[_ngcontent-%COMP%]{overflow:hidden;display:block}.brush-canvas[_ngcontent-%COMP%], .paint-canvas[_ngcontent-%COMP%]{position:absolute;top:0;z-index:10;transform-origin:0 0}.border-paint-canvas[_ngcontent-%COMP%]{pointer-events:none;z-index:10}.canvas-3[_ngcontent-%COMP%]{z-index:0}.canvas-2[_ngcontent-%COMP%]{z-index:1}"];
export { styles as styles };
